import React from "react";
import { Box, Button, Grid, Link, Stack, Typography } from "@mui/material";
import Instagram from "../../assets/images/social-icon-insta.svg";
import Twitter from "../../assets/icons/twitter-social-icon.svg";
import DiscordIcon from "../../assets/icons/discord-icon.svg";

const sxStyles = {
  mainContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    height: "200px",
    alignItems: "center",
    backgroundColor: "#160620",
  },
  socialContainer: {
    display: { xs: "flex", md: "none" },
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "30px",
    width: "200px",
  },
  footerText: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: "500",
    marginBottom: "20px",
  },
};

const Footer = () => {
  return (
    <Stack sx={sxStyles.mainContainer}>
      <Grid sx={sxStyles.socialContainer}>
        <Button
          sx={{
            "&.MuiButtonBase-root:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <img src={Instagram} />
        </Button>
        <Button
          sx={{
            "&.MuiButtonBase-root:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <img src={DiscordIcon} />
        </Button>
        <Button
          sx={{
            "&.MuiButtonBase-root:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <img src={Twitter} />
        </Button>
      </Grid>
      <Box
        sx={{
          display: { xs: "block", md: "flex" },
          flexDirection: { md: "row" },
          justifyContent: { md: "space-between" },
          width: { md: "40%" },
        }}
      >
        <Link
          underline={"always"}
          href={"https://bzrp.enigma.art/TermsAndConditions.pdf"}
        >
          <Typography sx={sxStyles.footerText}>
            Términos y condiciones del servicio
          </Typography>
        </Link>
        <Link href={"https://bzrp.enigma.art/PrivacyPolicies.pdf"}>
          <Typography sx={sxStyles.footerText}>
            Política de Privacidad
          </Typography>
        </Link>
      </Box>
    </Stack>
  );
};

export default Footer;
